import {fromJS} from 'immutable'
import {
  initialBoardData,
} from '../constants/initialData'
import {
  REMOVE_CARD,
  SET_CHOSEN_CARD,
  SET_WINNER,
} from '../constants/actionTypes'
import {isObjectsSame} from '../helpers/common'

const initialState = fromJS(initialBoardData);

const removeCard = (state, {rank, suit, type}) => {
  if (type) {
    const table = state.toJS().table;
    if (Array.isArray(table[type])) {
      const cardIndex = table[type].findIndex((card) => {
        return isObjectsSame(card, {rank, suit})
      });
      table[type][cardIndex] = false;
    } else {
      table[type] = false;
    }

    return fromJS({
      table,
      players: state.get('players'),
      winner: false,
      activeField: state.get('activeField'),
    });
  } else {
    const players = state.toJS().players;
    let i = 0;
    for (i; i < players.length; ++i) {
      const cardIndex = players[i].hand.findIndex((card) => {
        return isObjectsSame(card, {rank, suit})
      });

      if (cardIndex !== -1) {
        players[i].hand[cardIndex] = false;
        break;
      }
    }

    return fromJS({
      players,
      table: state.get('table'),
      winner: false,
      activeField: state.get('activeField'),
    });
  }
};

const setChosenCard = (state, {type, id}) => {
  const activeField = state.get('activeField').toJS();
  activeField.card.id = id;
  activeField.card.type = type || 'player';

  return fromJS({
    table: state.get('table'),
    winner: state.get('winner'),
    activeField: fromJS(activeField),
    players: state.get('players'),
  });
};

const setWinner = (state, {winner}) => {
  return state.set('winner', winner);
};

export default function board(state = initialState, action) {
  switch (action.type) {
    case REMOVE_CARD:
      return removeCard(state, action.payload);
    case SET_CHOSEN_CARD:
      return setChosenCard(state, action.payload);
    case SET_WINNER:
      return setWinner(state, action.payload);
    default:
      return state
  }
}